import { useEffect, useState } from "react";
import { authFetch } from "../api/api";
import UserFormModal from "./UserFormModal";
import "./UsersPage.css";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const loadAll = async () => {
    setLoading(true);
    setError(null);
    try {
      const [usersRes, groupsRes] = await Promise.all([
        authFetch(`${BASE_URL}/api/users/`),
        authFetch(`${BASE_URL}/api/users/groups/`),
      ]);
      if (!usersRes.ok) throw new Error(`users: ${usersRes.status}`);
      if (!groupsRes.ok) throw new Error(`groups: ${groupsRes.status}`);
      setUsers(await usersRes.json());
      setGroups(await groupsRes.json());
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  const handleCreated = (newUser) => {
    setUsers((prev) => [...prev, newUser]);
    setModalOpen(false);
  };

  return (
    <div className="users-page">
      <header className="users-page__header">
        <h1>Пользователи</h1>
        <button
          className="users-page__add"
          onClick={() => setModalOpen(true)}
        >
          + Добавить пользователя
        </button>
      </header>

      {loading && <div className="users-page__hint">Загрузка…</div>}
      {error && <div className="users-page__error">{error}</div>}

      {!loading && !error && (
        <table className="users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Логин</th>
              <th>ФИО</th>
              <th>Email</th>
              <th>Группы</th>
              <th>Активен</th>
              <th>Дата регистрации</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.username}</td>
                <td>{u.full_name || "—"}</td>
                <td>{u.email || "—"}</td>
                <td>
                  {u.groups?.length
                    ? u.groups.map((g) => g.name).join(", ")
                    : "—"}
                </td>
                <td>{u.is_active ? "да" : "нет"}</td>
                <td>
                  {u.date_joined
                    ? new Date(u.date_joined).toLocaleString()
                    : "—"}
                </td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr>
                <td colSpan={7} className="users-table__empty">
                  Пользователей пока нет
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {modalOpen && (
        <UserFormModal
          groups={groups}
          onClose={() => setModalOpen(false)}
          onCreated={handleCreated}
        />
      )}
    </div>
  );
}